import { openModal } from '@core/components/ModalStack';
import { ManageTMSectionsModalProps } from './ManageTMSectionsModal';

export async function openTMSectionModal(props: ManageTMSectionsModalProps) {
  const { ManageTMSectionsModal } = await import('./ManageTMSectionsModal');

  openModal(ManageTMSectionsModal, props);
}
